// 正式
module.exports = {
  title: '中国包装联合会',
  baseUrl: 'http://cpf.bjyyxx.cn/', // 正式项目地址
  baseApi: 'http://cpf.bjyyxx.cn/api/', // 正式api请求地址
  APPID: 'xxx',
  APPSECRET: 'xxx',
  $cdn: 'https://www.sunniejs.cn/static'
}
